var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8651 2.84124C16.4395 2.41541 15.9342 2.07761 15.3779 1.84714C14.8217 1.61667 14.2255 1.49805 13.6235 1.49805C13.0214 1.49805 12.4252 1.61667 11.869 1.84714C11.3128 2.07761 10.8074 2.41541 10.3818 2.84124L9.49847 3.72457L8.61514 2.84124C7.75539 1.98149 6.58933 1.49849 5.37347 1.49849C4.15761 1.49849 2.99155 1.98149 2.1318 2.84124C1.27206 3.70098 0.789063 4.86704 0.789062 6.0829C0.789062 7.29876 1.27206 8.46483 2.1318 9.32457L3.01514 10.2079L9.49847 16.6912L15.9818 10.2079L16.8651 9.32457C17.291 8.89894 17.6288 8.39358 17.8592 7.83736C18.0897 7.28115 18.2083 6.68497 18.2083 6.0829C18.2083 5.48083 18.0897 4.88465 17.8592 4.32844C17.6288 3.77222 17.291 3.26686 16.8651 2.84124Z",
    fill: "#FF7575",
    stroke: "#F03E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOn);
export default __webpack_public_path__ + "static/media/heart_on.2c846211f3b578af823f4c0bc724f5fa.svg";
export { ForwardRef as ReactComponent };